import React, {useState} from 'react'

import PicCont from './PicCont';



const CustomAlbum = ({ pictures, name }) => {
    let [pict, setPict] = useState(0)



 

    return <div className="album horizontal">
        <div className={`mainPic h`}>
        <PicCont key={pictures[pict]} background picture={pictures[pict]} alt={name} />
        </div>
        <div className="row">
           {pictures.map((p,i) => <PicCont width={500} className={'miniPic h'}  key={i} picture={p} alt={name + ` - #${i}`} onClick={() => setPict(i)} />) }
        </div>
    </div>





}

export default CustomAlbum